<template>
  <div class="LL_wrapper">
    <LectureWelcomeBox :lession="lession" v-bind:key="lession.id" v-for="lession in mylessions" />
  </div>
</template>

<script>
import LectureWelcomeBox from "@/components/LectureWelcomeBox";
export default {
  components: {
    LectureWelcomeBox,
  },
  computed: {
    mylessions() {
      return this.$store.state.mylessions;
    },
  },
};
</script>


<style lang="scss" scoped>
.LL_wrapper {
  width: 100%;
}
</style>